import { combineReducers } from "redux";
import { PayloadAction } from "@reduxjs/toolkit";
import settingSlice  from "@/redux/setting-slice/SettingSlice.ts";


const rootReducer = (asyncReducers?: any) => (state: any, action: PayloadAction) => {
  const combinedReducer = combineReducers({
    settingInfo: settingSlice,
    ...asyncReducers,
  });

  return combinedReducer(state, action);
};

export default rootReducer;